import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '../shared/core/state';
import * as UserActions from '../shared/core/state/users/user.actions';
import { selectTutorsList, selectTutorsLoading } from '../shared/core/state/users/user.selectors';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { SRI_LANKAN_DISTRICTS, SRI_LANKAN_SUBJECTS, SRI_LANKAN_GRADES } from '../shared/util/sri-lanka-data';
import { getResourcePath } from '../shared/util/helper.utils';
import { Resource } from '../shared/core/state/resource/models';

@Component({
  selector: 'black-tutors-directory',
  templateUrl: './tutors-directory.component.html',
  styleUrls: ['./tutors-directory.component.css'],
  standalone: false,
})
export class TutorsDirectoryComponent implements OnInit, OnDestroy {
  private store = inject<Store<State>>(Store);
  private sub = new Subscription();

  tutors: any[] = [];
  totalDocs = 0;
  page = 1;
  limit = 9;
  pages = 1;
  loading = false;

  // Filter lists
  subjectsList = SRI_LANKAN_SUBJECTS;
  districtsList = SRI_LANKAN_DISTRICTS;
  gradesList = SRI_LANKAN_GRADES;
  mediumsList = ['Sinhala', 'English', 'Tamil'];
  formatsList = ['Online', 'HomeVisit', 'Group', 'Institute'];

  // Filters State
  filters = {
    search: '',
    subject: '',
    medium: '',
    classFormat: '',
    district: '',
  };

  private searchSubject = new Subject<string>();

  ngOnInit(): void {
    // Listen to search subject with debounce
    this.sub.add(
      this.searchSubject.pipe(
        debounceTime(400),
        distinctUntilChanged()
      ).subscribe((val) => {
        this.filters.search = val;
        this.page = 1;
        this.fetchTutors();
      })
    );

    // Selectors
    this.sub.add(
      this.store.select(selectTutorsList).subscribe((list) => {
        if (list) {
          this.tutors = list.docs || [];
          this.totalDocs = list.totalDocs || 0;
          this.pages = list.totalPages || 1;
        }
      })
    );

    this.sub.add(
      this.store.select(selectTutorsLoading).subscribe((loading) => {
        this.loading = loading;
      })
    );

    this.fetchTutors();
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  fetchTutors() {
    this.store.dispatch(
      UserActions.loadTutors({
        page: this.page,
        limit: this.limit,
        filters: this.filters,
      })
    );
  }

  onSearch(event: any) {
    const val = event.target.value;
    this.searchSubject.next(val);
  }

  onFilterChange() {
    this.page = 1;
    this.fetchTutors();
  }

  clearFilters() {
    this.filters = {
      search: '',
      subject: '',
      medium: '',
      classFormat: '',
      district: '',
    };
    this.page = 1;
    this.fetchTutors();
  }

  onPageChange(page: number) {
    if (page >= 1 && page <= this.pages) {
      this.page = page;
      this.fetchTutors();
    }
  }

  getAvatarUrl(avatar: Resource | string | undefined): string {
    if (!avatar) return 'assets/img/default-avatar.png';
    return getResourcePath(avatar);
  }

  getPagesArray(): number[] {
    const arr = [];
    for (let i = 1; i <= this.pages; i++) {
      arr.push(i);
    }
    return arr;
  }
}
